import React from "react";
import { useSelector } from "react-redux";

import SectionWrapper from "../../../section-wrapper";
import SectionActions from "../../section-actions";
import AttendanceManagement from "./attendance-management";
import useAddOnController from "./controllers/use-add-on-controllers";
import CrossSkilling from "./cross-skilling";
import CustomerBoards from "./customer-boards";
import FlexSchedule from "./flex-schedule/flex-schedule";
import FullTimeScheduling
	from "./full-time-scheduling";
import JobsMatrix from "./jobs-matrix";
import Karma from "./karma/karma";
import SkillEvaluation from "./skill-evaluation";
import SupervisorDashboard from "./supervisor-dashboard";
import SupervisorMultilingual from "./supervisor-multilingual";
import WorkerSubType from "./worker-subtype";

interface IAddOnFeaturesProps {
	companyId: any;
	entity: string;
}
const AddOnFeatures: React.FC<IAddOnFeaturesProps> = ({
	companyId,
	entity,
}) => {
	const [
		{
			updateCompanySettingsLevelStatus,
			companyDataValue,
			addOnSettings,
			newAddOnSettings,
			updateCompanySettingsStatus,
			getCompanySettingsStatus,
			loading,
		},
		{ setNewAddOnSettings,
      handleSave,
      resetCompanyAbsenceManagementLocations,
      resetCompanyFullTimeScheduleLocations,
    },
	]: any = useAddOnController();

	const absenceManagementSelectedLocations = useSelector(
		(state: any) =>
			state.gatAdminConfiguration.updateCompanyAbsenceManagementLocationSettings
				.selectedLocations
	);

	const canNotSave =
		newAddOnSettings.absenceManagementEnabled &&
		absenceManagementSelectedLocations.length === 0;

	return (
		<SectionWrapper
			title='Add-On Features'
			subtitle='Additional to the existing core functionality'
		>
			<FlexSchedule
				newAddOnSettings={newAddOnSettings}
				setNewAddOnSettings={setNewAddOnSettings}
			/>
			<FullTimeScheduling
				companyId={companyId}
				newAddOnSettings={newAddOnSettings}
				setNewAddOnSettings={setNewAddOnSettings}
				loading={loading} />
			<WorkerSubType
				newAddOnSettings={newAddOnSettings}
				setNewAddOnSettings={setNewAddOnSettings}
			/>
			<CrossSkilling
				newAddOnSettings={newAddOnSettings}
				setNewAddOnSettings={setNewAddOnSettings}
				companySkillLevels={companyDataValue.skillLevels ?? []}
				updateCompanySettingsLevelStatus={updateCompanySettingsLevelStatus}
				companyId={companyId}
				entity={entity}
				handleSave={handleSave}
			/>
			<JobsMatrix
				newAddOnSettings={newAddOnSettings}
				setNewAddOnSettings={setNewAddOnSettings}
			/>
			<CustomerBoards
				newAddOnSettings={newAddOnSettings}
				setNewAddOnSettings={setNewAddOnSettings}
			/>
			<SkillEvaluation
				newAddOnSettings={newAddOnSettings}
				setNewAddOnSettings={setNewAddOnSettings}
			/>
			<Karma
				newAddOnSettings={newAddOnSettings}
				setNewAddOnSettings={setNewAddOnSettings}
			/>
			<AttendanceManagement
				companyId={companyId}
				newAddOnSettings={newAddOnSettings}
				setNewAddOnSettings={setNewAddOnSettings}
				loading={loading}
			/>
			<SupervisorMultilingual
				newAddOnSettings={newAddOnSettings}
				setNewAddOnSettings={setNewAddOnSettings}
			/>
			<SupervisorDashboard
				newAddOnSettings={newAddOnSettings}
				setNewAddOnSettings={setNewAddOnSettings}
			/>
			<SectionActions
				oldData={addOnSettings}
				newData={newAddOnSettings}
				companyDataValue={companyDataValue}
				resetChanges={() => {
          setNewAddOnSettings(addOnSettings);
          resetCompanyAbsenceManagementLocations();
          resetCompanyFullTimeScheduleLocations();
        }}
				handleSave={handleSave}
				status={
					updateCompanySettingsStatus === "pending" ||
					getCompanySettingsStatus === "pending"
						? "pending"
						: "fulfilled"
				}
				loading={loading}
				canNotSave={canNotSave}
			/>
		</SectionWrapper>
	);
};

export default AddOnFeatures;
